import { publicApi } from "./api";

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Human labels for each form that feeds the submissions inbox. */
export const FORM_TYPES = [
  { id: "guest_spot", label: "Guest spot", description: "Artists applying through the Guest Spot Registry." },
  { id: "lead", label: "Promo lead", description: "Lead forms placed on your landing pages." },
  { id: "contact", label: "Contact", description: "The contact form at the bottom of the main site." },
];

export const formLabel = (id) => FORM_TYPES.find((f) => f.id === id)?.label || id;

export const STATUS_OPTIONS = [
  { id: "new", label: "New" },
  { id: "read", label: "Read" },
  { id: "replied", label: "Replied" },
  { id: "archived", label: "Archived" },
];

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

const utmFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return Object.fromEntries(UTM_KEYS.map((k) => [k, (params.get(k) || "").slice(0, 200)]));
};

/** Sends a public form to the backend with the current page + campaign context attached. */
export const submitForm = (formType, fields, extra = {}) =>
  publicApi.submitForm({
    form_type: formType,
    fields,
    path: window.location.pathname + window.location.hash,
    referrer: (document.referrer || "").slice(0, 500),
    ...utmFromUrl(),
    ...extra,
  });

/** "a@b.com, c@d.com" -> ["a@b.com", "c@d.com"] (keeps a trailing empty entry so typing a comma still works). */
export const splitEmails = (text) => text.split(/[,\n;]/).map((s) => s.trim().toLowerCase());
export const cleanEmails = (list) => Array.from(new Set((list || []).map((s) => s.trim().toLowerCase()).filter(Boolean)));
